// disable-cart-redirect.js
document.addEventListener('DOMContentLoaded', function() {
  // Function to handle form submission
  async function handleAddToCart(e) {
    // Prevent default behavior completely
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    
    // Check if pickup is available, and if not, clear location selection before adding to cart
    const api = window.inventoryInfo?.api;
    let shouldClearLocation = false;
    
    // Method 1: Check via buy-online component (product pages and quick view drawer)
    // First check in quick view drawer, then check main page
    const quickViewDrawer = form.closest('.quick-view, quick-view-modal');
    let buyOnlineElement = null;
    
    if (quickViewDrawer) {
      // Look for buy-online component within the quick view drawer
      buyOnlineElement = quickViewDrawer.querySelector('[data-buy-online]');
    }
    
    // If not found in quick view, check main page
    if (!buyOnlineElement) {
      buyOnlineElement = document.querySelector('[data-buy-online]');
    }
    
    if (buyOnlineElement && buyOnlineElement.__buyOnlineInstance) {
      const buyOnline = buyOnlineElement.__buyOnlineInstance;
      // Check if pickup is available (only check if locations have loaded)
      if (buyOnline.locationsLoaded && !buyOnline.pickupAvailable) {
        shouldClearLocation = true;
      }
    }
    
    // Method 2: Check via product card data attribute (collection pages and quick view)
    if (!shouldClearLocation && api?.getSelectedLocationId) {
      try {
        const selectedLocationId = await api.getSelectedLocationId();
        // Only check if a location is actually selected
        if (selectedLocationId && selectedLocationId !== -1 && selectedLocationId !== '-1') {
          // First, try to find product card containing this form (collection pages)
          let productCard = form.closest('.product-card');
          
          // If not found, try to find in quick view drawer (quick view context)
          if (!productCard && quickViewDrawer) {
            productCard = quickViewDrawer.querySelector('.product-card, .product');
          }
          
          if (productCard) {
            // Check if the product card has pickup availability for the selected location
            const inStockElement = productCard.querySelector('[data-location-ids]');
            if (inStockElement) {
              const locationIds = inStockElement.getAttribute('data-location-ids');
              if (locationIds) {
                const locationIdsArray = locationIds.split(',').map(id => String(id).trim());
                const selectedLocationIdStr = String(selectedLocationId);
                // If selected location is not in the list, pickup is not available
                if (!locationIdsArray.includes(selectedLocationIdStr)) {
                  shouldClearLocation = true;
                }
              } else {
                // No location IDs means no pickup availability
                shouldClearLocation = true;
              }
            } else {
              // No data-location-ids element means no pickup availability
              shouldClearLocation = true;
            }
          }
        }
      } catch (error) {
        console.warn('[disable-cart-redirect] Failed to check location availability', error);
      }
    }
    
    // Clear location selection if pickup is not available
    if (shouldClearLocation && api?.selectLocation) {
      try {
        // Clear selection by selecting -1 (default/no location)
        await api.selectLocation(-1);
        
        // Also clear the buy-online component's selection if it exists
        if (buyOnlineElement && buyOnlineElement.__buyOnlineInstance) {
          const buyOnline = buyOnlineElement.__buyOnlineInstance;
          buyOnline.currentSelectionId = null;
          buyOnline.setSelectedStore('');
          buyOnline.setSelectedDetails({});
        }
        
        // Update the banner store selector to clear the selection
        const headerStoreSelector = document.querySelector('#header-store-selector');
        if (headerStoreSelector && typeof headerStoreSelector.clearSelection === 'function') {
          headerStoreSelector.clearSelection();
        } else if (headerStoreSelector && typeof headerStoreSelector.setActiveValue === 'function') {
          headerStoreSelector.setActiveValue('', '');
        }
        
        // Dispatch store-selector:change event to ensure banner updates
        document.dispatchEvent(
          new CustomEvent('store-selector:change', { 
            detail: { 
              id: '', 
              label: '',
              mode: ''
            } 
          })
        );
        
        // Clear cart attributes
        if (typeof window.updatePickupCartAttributes === 'function') {
          await window.updatePickupCartAttributes({ mode: '', id: '', name: '' });
        }
      } catch (error) {
        console.warn('[disable-cart-redirect] Failed to clear location selection', error);
      }
    }
    
    const submitButton = form.querySelector('[type="submit"]');
    let originalText = '';
    
    try {
      // Show loading state
      if (submitButton) {
        originalText = submitButton.innerHTML;
        submitButton.innerHTML = 'Adding...';
        submitButton.setAttribute('disabled', 'disabled');
      }
      
      // Get sections to update from theme
      const sections = [];
      document.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections }
        })
      );
      
      // Prepare form data with sections
      const formData = new FormData(form);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
      
      // Submit to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) throw new Error('Network response was not ok');
      
      const result = await response.json();
      
      // Update cart through theme's pubsub system
      if (window.FoxTheme?.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: result
        });
      }
      
      // Show success message
      if (window.FoxTheme?.notification) {
        FoxTheme.notification.show('Item added to cart');
      } else {
        // Fallback notification
        const notification = document.createElement('div');
        notification.style.position = 'fixed';
        notification.style.bottom = '20px';
        notification.style.right = '20px';
        notification.style.padding = '10px 20px';
        notification.style.background = '#000';
        notification.style.color = '#fff';
        notification.style.borderRadius = '4px';
        notification.style.zIndex = '9999';
        notification.innerText = 'Item added to cart';
        document.body.appendChild(notification);
        setTimeout(() => notification.remove(), 3000);
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      // Show error message
      alert('Could not add item to cart. Please try again.');
    } finally {
      // Reset button state
      if (submitButton && originalText) {
        submitButton.innerHTML = originalText;
        submitButton.removeAttribute('disabled');
      }
    }
  }

  // Nuclear option to catch all possible click events
  function nuclearOption(e) {
    if (e.target.closest('form[action="/cart/add"] [type="submit"], form[action="/cart/add"] button')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      handleAddToCart(e);
    }
  }

  // Function to set up form handlers for dynamically loaded forms
  function setupFormHandlers(container = document) {
    container.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      // Skip if already processed
      if (form.dataset.cartRedirectHandled) return;
      
      // Clone form to remove all existing listeners
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);
      
      // Mark as processed
      newForm.dataset.cartRedirectHandled = 'true';
      
      // Add our submit handler
      newForm.addEventListener('submit', handleAddToCart);
      
      // Also catch button clicks directly
      newForm.querySelectorAll('[type="submit"], button').forEach(button => {
        button.addEventListener('click', handleAddToCart);
      });
    });
  }

  // Set up handlers for initial page load
  setupFormHandlers();

  // Add capture-phase listener as safety net
  window.addEventListener('submit', nuclearOption, true);
  window.addEventListener('click', nuclearOption, true);
  
  // Listen for quick view loaded event to set up handlers for dynamically loaded forms
  document.addEventListener('quick-view:loaded', function(e) {
    // Find the quick view drawer
    const quickViewDrawer = document.querySelector('.quick-view-modal:not([hidden]), quick-view-modal:not([hidden])');
    if (quickViewDrawer) {
      // Wait a bit for content to be fully inserted
      setTimeout(() => {
        setupFormHandlers(quickViewDrawer);
      }, 100);
    }
  });
});

// Extra protection against turbolinks/page transitions
if (window.turbolinks) {
  document.addEventListener('turbolinks:load', function() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      });
    });
  });
}
